define.alias("ember-math-helpers/helpers/cbrt", "settings/helpers/cbrt");